<script setup lang="ts">
import CheckIcon from './check.svg'

const props = defineProps<{
  checked: boolean
  disabled?: boolean
  id: string
  labelText?: string
}>()
const emit = defineEmits<{
  change: []
}>()

const onChange = (): void => {
  if (props.disabled) return
  emit('change')
}
</script>

<template>
  <label
    class="flex items-center gap-4"
    :class="[
      props.disabled ? 'cursor-not-allowed text-black-400' : 'cursor-pointer text-black-900',
    ]"
    :for="id"
  >
    <div class="relative">
      <div
        class="absolute left-0 right-0 top-1/2 flex aspect-square -translate-y-1/2 items-center justify-center rounded"
        :class="{
          'bg-lochmara-600': checked && !props.disabled,
          'bg-black-300': checked && props.disabled,
          'border border-black-200 bg-white': !checked && !props.disabled,
          'border border-black-100 bg-black-100': !checked && props.disabled,
        }"
      >
        <!-- Only when checked: the white icon was "hidden" on the white box, visible in dark. -->
        <img v-if="checked" alt="" :src="CheckIcon" />
      </div>

      <input
        :id="id"
        :checked
        class="z-[-1] h-5 w-5 focus:ring-0 focus:ring-offset-0"
        :disabled="props.disabled ?? false"
        type="checkbox"
        @change="onChange"
      />
    </div>
    {{ labelText ?? '' }}</label
  >
</template>

<style scoped>
/* TODO: use tailwind appearance-none */
input[type='checkbox'] {
  appearance: none;
  -webkit-appearance: none;
  accent-color: transparent;
  outline: none;
  position: relative;
  border: none;
}
</style>
